export const RESERVED_API_HEADERS = [
    'accept',
    'x-anwb-client-id',
    'x-anwb-client-secret',
    'x-anwb-statistics-application',
];
export const filterApiHeaders = (apiHeader) => {
    if (apiHeader === undefined)
        return {};
    return Object.fromEntries(Object.entries(apiHeader).filter(([key]) => {
        return !RESERVED_API_HEADERS.includes(key);
    }));
};
